import { IApiService, IInvitationService } from '@/interfaces/Services';
import { inject, injectable } from 'inversify';
import { InvitationModel } from '@/models/invitation';
import DependencyIdentifiers from '@/ioc/DependencyIdentifiers';

@injectable()
export default class InvitationService implements IInvitationService {
  private _api: IApiService;

  constructor(@inject(DependencyIdentifiers.ApiService) api: IApiService) {
    this._api = api;
  }

  async create(invitation: InvitationModel): Promise<InvitationModel> {
    return await this._api
      .post<{ data: InvitationModel }>('/invitations', { data: invitation })
      .then(result => result.data);
  }

  async verify(id: string, code: string): Promise<boolean> {
    return await this._api
      .post<{ data: boolean }>(`/invitations/${id}/verify`, {data: { code}})
      .then(result => result.data);
  }
}
